define("shared/components/shared/post/secondary/activity/body", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.canUsePostActivityLog}}
    <div
      class={{concat-classes
        "o--modalBody--secondary cAP--modalBody--secondary cAP--list"
        (unless @formattedPostActivities.length "is--empty u--text--light")
      }}
      data-test-id="post-activity-body"
      {{perfect-scroll @scrollbarId}}
    >
      {{#if @formattedPostActivities.length}}
        <ul class="cAP--list qa--activity_modal_commentList">
          {{#each @formattedPostActivities as |formattedPostActivity|}}
            {{#if (eq formattedPostActivity.type "divider")}}
              {{! Date Divider}}
              <Shared::Post::Secondary::Activity::Divider @divider={{formattedPostActivity}} />
            {{else if (eq formattedPostActivity.type "comment")}}
              {{! Comments }}
              <Shared::Post::Secondary::Activity::Comment @comment={{formattedPostActivity}} />
            {{else if (eq formattedPostActivity.type "action")}}
              {{! Action }}
              <Shared::Post::Secondary::Activity::Action @action={{formattedPostActivity}} />
            {{/if}}
          {{/each}}
        </ul>
      {{else}}
        <div class="img--empty__conversations"></div>
        <span class="u--m__b__0 u--m__t__md">
          {{t "approval.secondary-modal.body.no_activity"}}
        </span>
      {{/if}}
    </div>
    {{#if this.showAddUsers}}
      <div class="cAP--modalBody--banner">
        <span>{{t "approval.secondary-modal.body.add_users_cta"}}</span>
        <Shared::Ui::Button
          @promise={{this.redirectToGroupMembers}}
          @text={{t "approval.secondary-modal.body.add_users"}}
          @variant="unstyled"
          aria-label={{t "approval.secondary-modal.body.add_users"}}
          class="u--p__0 u--text--hl"
        />
      </div>
    {{/if}}
  {{else}}
    <div class="o--modalBody--secondary cAP--modalBody--secondary">
      <div class="cAP--modalBody--upgrade">
        <p class="u--text--bold">{{t "approval.secondary-modal.upgrade.title"}}</p>
        <p class="u--m__0">{{t "approval.secondary-modal.upgrade.subtitle"}}</p>
  
        <hr class="u--m__tb" />
        <p>{{html-safe (t "approval.secondary-modal.upgrade.advanced_plan_includes")}}</p>
  
        <ul class="u--listUnstyle u--m__b__md">
          <li>
            {{svg-jar "verified" class="o--icon u--text--success"}}
            <span>{{t "approval.secondary-modal.upgrade.post_comments"}}</span>
          </li>
        </ul>
  
        <Shared::Button::Upgrade
          @feature="postActivity"
          @location="post activity secondary modal"
          class="u--p__lr o--btn--lg o--btn--block"
        />
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "hOi0Jzpl",
    "block": "[[[41,[30,0,[\"canUsePostActivityLog\"]],[[[1,\"  \"],[11,0],[16,0,[28,[37,1],[\"o--modalBody--secondary cAP--modalBody--secondary cAP--list\",[52,[51,[30,1,[\"length\"]]],\"is--empty u--text--light\"]],null]],[24,\"data-test-id\",\"post-activity-body\"],[4,[38,3],[[30,2]],null],[12],[1,\"\\n\"],[41,[30,1,[\"length\"]],[[[1,\"      \"],[10,\"ul\"],[14,0,\"cAP--list qa--activity_modal_commentList\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,1]],null]],null],null,[[[41,[28,[37,6],[[30,3,[\"type\"]],\"divider\"],null],[[[1,\"            \"],[8,[39,7],null,[[\"@divider\"],[[30,3]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,3,[\"type\"]],\"comment\"],null],[[[1,\"            \"],[8,[39,8],null,[[\"@comment\"],[[30,3]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,3,[\"type\"]],\"action\"],null],[[[1,\"            \"],[8,[39,9],null,[[\"@action\"],[[30,3]]],null],[1,\"\\n          \"]],[]],null]],[]]]],[]]]],[3]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"img--empty__conversations\"],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--m__b__0 u--m__t__md\"],[12],[1,\"\\n        \"],[1,[28,[35,10],[\"approval.secondary-modal.body.no_activity\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[41,[30,0,[\"showAddUsers\"]],[[[1,\"    \"],[10,0],[14,0,\"cAP--modalBody--banner\"],[12],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,10],[\"approval.secondary-modal.body.add_users_cta\"],null]],[13],[1,\"\\n      \"],[8,[39,11],[[16,\"aria-label\",[28,[37,10],[\"approval.secondary-modal.body.add_users\"],null]],[24,0,\"u--p__0 u--text--hl\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"redirectToGroupMembers\"]],[28,[37,10],[\"approval.secondary-modal.body.add_users\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"  \"],[10,0],[14,0,\"o--modalBody--secondary cAP--modalBody--secondary\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cAP--modalBody--upgrade\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,10],[\"approval.secondary-modal.upgrade.title\"],null]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__0\"],[12],[1,[28,[35,10],[\"approval.secondary-modal.upgrade.subtitle\"],null]],[13],[1,\"\\n\\n      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,12],[[28,[37,10],[\"approval.secondary-modal.upgrade.advanced_plan_includes\"],null]],null]],[13],[1,\"\\n\\n      \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--m__b__md\"],[12],[1,\"\\n        \"],[10,\"li\"],[12],[1,\"\\n          \"],[1,[28,[35,13],[\"verified\"],[[\"class\"],[\"o--icon u--text--success\"]]]],[1,\"\\n          \"],[10,1],[12],[1,[28,[35,10],[\"approval.secondary-modal.upgrade.post_comments\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,14],[[24,0,\"u--p__lr o--btn--lg o--btn--block\"]],[[\"@feature\",\"@location\"],[\"postActivity\",\"post activity secondary modal\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@formattedPostActivities\",\"@scrollbarId\",\"formattedPostActivity\"],false,[\"if\",\"concat-classes\",\"unless\",\"perfect-scroll\",\"each\",\"-track-array\",\"eq\",\"shared/post/secondary/activity/divider\",\"shared/post/secondary/activity/comment\",\"shared/post/secondary/activity/action\",\"t\",\"shared/ui/button\",\"html-safe\",\"svg-jar\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/body.hbs",
    "isStrictMode": false
  });
  let BodyComponent = _exports.default = (_class = class BodyComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _defineProperty(this, "redirectToGroupMembers", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.args.hasUnsavedChanges) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
              description: this.intl.t('post.unsaved_changes'),
              cancelButton: this.intl.t('shared_words.cancel'),
              confirmButton: this.intl.t('shared_words.leave')
            });
            if (!didConfirm) {
              return;
            }
          }
          this.router.transitionTo('account.groups.group.members', this.auth.currentGroup.id);
        }
      }), null, "redirectToGroupMembers", null));
    }
    get canUsePostActivityLog() {
      return Boolean(this.auth.currentAccount.canUsePostActivityLog);
    }
    get showAddUsers() {
      return this.auth.currentUserModel.isAccountOwner && this.auth.currentGroup.nonContributorMemberCount === 1;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BodyComponent);
});